<div class="body">

    <div class="main-editar-resultados">

        <mat-toolbar class="mat-elevation-z2 noselect toolbar-titulo">
            <div class="loading-shade" id="carregamento" style="visibility: hidden;">
                <mat-spinner></mat-spinner>
            </div>

            <div class="div-botao-voltar" (click)="voltar()">
                <mat-icon style="color: #ff0000"> navigate_before </mat-icon>
                <button mat-button class="botao-voltar">
                    <p class="p-botao-voltar">
                        Voltar
                    </p>
                </button>
            </div>

            <span class="barra-topo"></span>

            <div class="div-editar-resultados">
                <p class="p-editar-resultados">
                    Editar Resultados
                </p>
            </div>

        </mat-toolbar>

        <div class="div-body">

            <div class="div-form">

                <div class="content" *ngIf="!isLoadingResults">

                    <form [formGroup]="formDadosCliente">

                        <div class="grid grid--auto-fill">

                            <mat-form-field style="pointer-events: none;" class="nopadding paddinglados">
                                <mat-label style="font-size: 20px; border: 0;"><strong>Data e Hora do
                                        Atendimento:</strong></mat-label>
                                <input formControlName="dataeHoradoAtendimento" matInput type="datetime">
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados">
                                <mat-label style="font-size: 20px;"><strong>Usuario do Cadastro:</strong>
                                </mat-label>
                                <input formControlName="nomeUsuarioCadastroAtendimento" type="text" matInput>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados">
                                <mat-label style="font-size: 20px;"><strong>Nome do Cliente:</strong></mat-label>
                                <input appTitlecase formControlName="nomedoCliente" matInput>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados">
                                <mat-label style="font-size: 20px;"><strong>Como nos Conheceu:</strong></mat-label>
                                <mat-select formControlName="comonosConheceu">
                                    <mat-option [value]="1"> Indicação </mat-option>
                                    <mat-option [value]="2"> Google </mat-option>
                                    <mat-option [value]="3"> Facebook </mat-option>
                                    <mat-option [value]="4"> Instagram </mat-option>
                                    <mat-option [value]="5"> WhatsApp </mat-option>
                                    <mat-option [value]="22"> YouTube </mat-option>
                                    <mat-option [value]="23"> TikTok </mat-option>
                                    <mat-option [value]="6"> Passou em frente </mat-option>
                                    <mat-option [value]="7"> Panfleto </mat-option>
                                    <mat-option [value]="8"> Cartaz </mat-option>
                                    <mat-option [value]="9"> Faixa na rua </mat-option>
                                    <mat-option [value]="10"> Ônibus </mat-option>
                                    <mat-option [value]="11"> Jornal </mat-option>
                                    <mat-option [value]="12"> Televisão </mat-option>
                                    <mat-option [value]="13"> Rádio </mat-option>
                                    <mat-option [value]="14"> Chat On-Line </mat-option>
                                    <mat-option [value]="15"> Lista Telefônica </mat-option>
                                    <mat-option [value]="16"> Tele-Responde </mat-option>
                                    <mat-option [value]="17"> Pesquisa </mat-option>
                                    <mat-option [value]="18"> Outdoor </mat-option>
                                    <mat-option [value]="19"> Muro </mat-option>
                                    <mat-option [value]="20"> Leadster </mat-option>
                                    <mat-option [value]="22"> Comunidade WhatsApp </mat-option>
                                    <mat-option [value]="21"> Outros </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados">
                                <mat-label style="font-size: 20px;"><strong>Celular:</strong></mat-label>
                                <input formControlName="celular" id="idCelular" [mask]="maskCelular" matInput>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados">
                                <mat-label style="font-size: 20px;"><strong>Periodo:</strong></mat-label>
                                <mat-select formControlName="periodo">
                                    <mat-option [value]="1"> A Distância </mat-option>
                                    <mat-option [value]="2"> Noite </mat-option>
                                    <mat-option [value]="3"> Manhã </mat-option>
                                    <mat-option [value]="4"> Tarde </mat-option>
                                    <mat-option [value]="5"> Indeciso </mat-option>
                                    <mat-option [value]="6"> Revesado </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados">
                                <mat-label style="font-size: 20px;"><strong>Canal de Atendimento:</strong>
                                </mat-label>
                                <mat-select formControlName="canaldeAtendimento">
                                    <mat-option [value]="1"> Telefone </mat-option>
                                    <mat-option [value]="2"> Balcão </mat-option>
                                    <mat-option [value]="3"> Facebook </mat-option>
                                    <mat-option [value]="4"> WhatsApp </mat-option>
                                    <mat-option [value]="5"> Instagram </mat-option>
                                    <mat-option [value]="6"> E-mail </mat-option>
                                    <mat-option [value]="7"> Formulário Google </mat-option>
                                    <mat-option [value]="8"> Dashboard Site </mat-option>
                                    <mat-option [value]="9"> Formulário Site </mat-option>
                                    <mat-option [value]="10"> Leadster </mat-option>
                                    <mat-option [value]="11"> Outros </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados">
                                <mat-label style="font-size: 20px;"><strong>Motivo de Interesse no Curso:</strong>
                                </mat-label>
                                <mat-select formControlName="motivodeInteressenoCurso">
                                    <mat-option [value]="1"> Emprego </mat-option>
                                    <mat-option [value]="2"> Faculdade/Curso </mat-option>
                                    <mat-option [value]="3"> Concurso </mat-option>
                                    <mat-option [value]="4"> Realização Pessoal </mat-option>
                                    <mat-option [value]="5"> Outros </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados">
                                <mat-label style="font-size: 20px;"><strong>Agendamento da Matrícula:</strong>
                                </mat-label>
                                <mat-select formControlName="agendamentodaMatricula"
                                    (selectionChange)="agendamentoSimNao()">
                                    <!-- (selectionChange)="agendamentoSimNao()" -->
                                    <mat-option [value]="1"> Secretaria </mat-option>
                                    <mat-option [value]="2"> Delivery </mat-option>
                                    <mat-option [value]="3"> Não </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados"
                                *ngIf="agendamentoSim == 1 || agendamentoSim == 2">
                                <mat-label style="font-size: 20px;"><strong>Dia do Agendamento</strong></mat-label>
                                <input formControlName="diadoAgendamento" matInput [min]="minDate"
                                    [matDatepicker]="picker1" readonly=“true”>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker touchUi #picker1></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados"
                                *ngIf="agendamentoSim == 1 || agendamentoSim == 2">
                                <mat-label style="font-size: 20px;"><strong>Hora do Agendamento</strong></mat-label>
                                <input formControlName="horadoAgendamento" type="time" matInput>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados"
                                *ngIf="agendamentoSim == 3 || agendamentoSim == 0">
                                <mat-label style="font-size: 20px;"><strong>Motivo do Não Agendamento:</strong>
                                </mat-label>
                                <mat-select formControlName="motivodoNaoAgendamento">
                                    <mat-option [value]="1"> Cliente Está Indeciso </mat-option>
                                    <mat-option [value]="2"> Desempregado </mat-option>
                                    <mat-option [value]="3"> Sem Condições Financeiras </mat-option>
                                    <mat-option [value]="4"> Para outra pessoa </mat-option>
                                    <mat-option [value]="5"> Confirmar com terceiros </mat-option>
                                    <mat-option [value]="6"> Não Tem Idade Para Matrícula </mat-option>
                                    <mat-option [value]="7"> Ligação Caiu </mat-option>
                                    <mat-option [value]="8"> Lançamento Mídias </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="nopadding paddinglados">
                                <mat-label style="font-size: 20px;"><strong>Observações:</strong></mat-label>
                                <input appTitlecase formControlName="observacoes" matInput>
                            </mat-form-field>

                            <div class="div-botoes">

                                <button mat-raised-button class="b-historico-tentativas"
                                    (click)="abrirHistoricoAgendamento()">
                                    <p class="p-historico-tentativas">
                                        Histórico de Agendamentos
                                    </p>
                                </button>

                                <button mat-raised-button class="b-salvar" (click)="editarDados()">
                                    <p class="p-salvar">
                                        Salvar
                                    </p>
                                </button>

                            </div>

                        </div>

                    </form>

                </div>

            </div>

        </div>

        <div class="div-rodape">

            <div class="div-barra-navegacao">

                <button class="b-home">
                    <mat-icon class="mat-icon-button" (click)="goToHome()"> home </mat-icon>
                </button>

                <button class="b-novo-atendimento">
                    <mat-icon class="mat-icon-button" (click)="goToNovoAtendimento()"> add </mat-icon>
                </button>

                <button class="b-pesquisar">
                    <mat-icon class="mat-icon-button" (click)="goToPesquisar()"> search </mat-icon>
                </button>

                <button class="b-agendados">
                    <mat-icon class="mat-icon-button" (click)="goToAgendados()"> calendar_today </mat-icon>
                </button>
            </div>

        </div>

    </div>

</div>